const garbaConfig = {
  businessName: "Raas Rhythm Garba Academy",
  businessCategory: "Garba Classes",
  productsLabel: "Our Programs",
  tagline: "Learn Traditional Garba with Passion, Rhythm & Perfection",
  description:
    "One of Gujarat's leading Garba academies offering professional Garba training, personal coaching, group batches, wedding choreography, corporate workshops, competition preparation, and Navratri passes.",
  mission:
    "To preserve the soul of Gujarati folk dance by delivering world-class Garba training that blends tradition with modern performance excellence.",
  vision:
    "To be Gujarat's most trusted Garba academy — nurturing confident, skilled, and culturally rooted dancers across every age group.",
  logo: null,
  favicon: null,
  theme: {
    primaryColor: "#C62828",
    secondaryColor: "#F9A825",
    accentColor: "#2E7D32",
    backgroundColor: "#FFF8E7",
    textColor: "#212121",
    darkBackground: "#1a0800",
    darkText: "#FFF8E7",
    borderRadius: "12px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  darkModeEnabled: true,
  defaultDarkMode: false,
  seo: {
    title: "Raas Rhythm Garba Academy | Best Garba Classes in Gujarat",
    description:
      "Join Raas Rhythm Garba Academy for professional Garba classes in Ahmedabad, Vadodara, Surat, Rajkot & Gandhinagar. Beginner to advanced, kids to adults, wedding choreography & competition training.",
    keywords:
      "Garba Classes Gujarat, Garba Classes Ahmedabad, Garba Academy, Navratri Classes, Dandiya Classes, Wedding Garba Choreography, Personal Garba Training, Corporate Garba Workshop, Kids Garba Classes, Best Garba Classes in Gujarat",
    ogImage:
      "https://images.unsplash.com/photo-1504609813442-a8924e83f76e?w=1200&q=80",
    twitterCard: "summary_large_image",
  },
  contact: {
    phone: "+91 98765 00001",
    whatsapp: "919876500001",
    email: "info@raasrhythm.com",
    website: "www.raasrhythm.com",
    address: "301, Sanskruti Plaza, Navrangpura, Ahmedabad - 380009, Gujarat",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235013.87619816!2d72.43334!3d23.02579!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e848aba5bd449%3A0x4fcedd11614f6516!2sAhmedabad%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1718000000000",
  },
  businessHours: [
    { day: "Monday - Friday", hours: "6:00 AM - 9:00 AM & 5:00 PM - 9:00 PM" },
    { day: "Saturday - Sunday", hours: "7:00 AM - 1:00 PM & 4:00 PM - 8:00 PM" },
    { day: "Navratri Season", hours: "Special Extended Hours - All Day" },
  ],
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    linkedin: "",
    youtube: "https://youtube.com",
    twitter: "",
  },
  hero: {
    heading: "Celebrate Every Step of Garba",
    subheading:
      "Master Traditional & Modern Garba with Gujarat's Professional Instructors",
    ctaPrimary: { label: "Join Today", link: "/garba/contact" },
    ctaSecondary: { label: "Book Free Demo", link: "/garba/contact" },
    images: [
      "https://images.unsplash.com/photo-1504609813442-a8924e83f76e?w=1400&q=80",
      "https://images.unsplash.com/photo-1545959570-a94084071b5d?w=1400&q=80",
      "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=1400&q=80",
    ],
  },
  about: {
    heading: "About Raas Rhythm Garba Academy",
    subheading: "Shaping Gujarat's Finest Garba Dancers Since 2015",
    body: "Founded in 2015, Raas Rhythm Garba Academy has grown into one of Gujarat's most respected dance institutions. With 15,000+ students trained across Ahmedabad, Vadodara, Rajkot, Surat, and Gandhinagar, we bring together the authenticity of traditional Garba and the energy of modern performance. Our expert instructors, structured batches, and stage opportunities make us the first choice for families, professionals, and competitive dancers alike.",
    highlights: [
      "15,000+ Students Trained",
      "5 Cities Covered",
      "Established 2015",
      "Competition Champions",
    ],
    image:
      "https://images.unsplash.com/photo-1545959570-a94084071b5d?w=800&q=80",
  },

  services: [
    { id: 1,  icon: "FaGraduationCap", title: "Beginner Garba Classes",        description: "Start your Garba journey with foundational 2-step, 3-step, and basic Raas patterns. No prior experience needed.", image: "" },
    { id: 2,  icon: "FaCalendarAlt",   title: "Intermediate Garba",            description: "Build on your basics with complex footwork, hand gestures, and multi-step Garba sequences.", image: "" },
    { id: 3,  icon: "FaChartLine",     title: "Advanced Garba",                description: "Master high-energy choreography, stage formations, and fusion Garba for performances and competitions.", image: "" },
    { id: 4,  icon: "FaUserMd",        title: "Personal Coaching",             description: "One-on-one sessions tailored to your pace, goals, and performance requirements.", image: "" },
    { id: 5,  icon: "FaHandsHelping",  title: "Group Coaching",                description: "Energetic group sessions that build teamwork, rhythm, and community spirit.", image: "" },
    { id: 6,  icon: "FaHeartbeat",     title: "Couple Garba Classes",          description: "Learn partner-based Garba and Dandiya Raas — perfect for weddings, events, and Navratri.", image: "" },
    { id: 7,  icon: "FaChild",         title: "Kids Garba Classes",            description: "Fun, age-appropriate Garba for children aged 4-14. Builds rhythm, confidence, and cultural pride.", image: "" },
    { id: 8,  icon: "FaSpa",           title: "Wedding Garba Choreography",    description: "Custom wedding choreography for Sangeet, Garba nights, and family performances.", image: "" },
    { id: 9,  icon: "FaBuilding",      title: "Corporate Workshops",           description: "Team-building Garba workshops for offices, corporate events, and company celebrations.", image: "" },
    { id: 10, icon: "FaGraduationCap", title: "College Garba Workshops",       description: "High-energy Garba workshops for college fests, cultural events, and youth programs.", image: "" },
    { id: 11, icon: "FaShieldAlt",     title: "Competition Preparation",       description: "Intensive training for state and national Garba competitions with expert coaching.", image: "" },
    { id: 12, icon: "FaCalendarAlt",   title: "Navratri Performance Training", description: "Dedicated pre-Navratri training covering all 9 nights' choreography, costumes, and stage presence.", image: "" },
    { id: 13, icon: "FaMobileAlt",     title: "Online Garba Classes",          description: "Live and recorded Garba classes accessible from anywhere in India and abroad.", image: "" },
  ],

  stats: [
    { value: 15000, label: "Students Trained",     suffix: "+" },
    { value: 9,     label: "Years of Excellence",  suffix: "+" },
    { value: 5,     label: "Cities Covered",       suffix: "" },
    { value: 200,   label: "Competitions Won",     suffix: "+" },
  ],

  whyUs: {
    heading: "Why Choose Raas Rhythm?",
    subheading: "Where tradition meets world-class training",
    points: [
      { icon: "FaGraduationCap", title: "Expert Instructors",    description: "Trained under Gujarat's finest Garba Gurus with decades of performance and teaching experience." },
      { icon: "FaCalendarAlt",   title: "Flexible Batches",      description: "Morning, evening, weekend, and online batches to fit every schedule — kids to adults." },
      { icon: "FaShieldAlt",     title: "Safe & Inclusive",      description: "A warm, family-like environment where every student feels welcome, respected, and celebrated." },
      { icon: "FaCamera",        title: "Stage Opportunities",   description: "Regular performances at Navratri events, cultural festivals, competitions, and weddings." },
    ],
  },

  gallery: [
    { id: 1,  src: "https://images.unsplash.com/photo-1504609813442-a8924e83f76e?w=800&q=80", alt: "Garba Performance",        category: "Performance" },
    { id: 2,  src: "https://images.unsplash.com/photo-1545959570-a94084071b5d?w=800&q=80", alt: "Dandiya Raas Night",       category: "Performance" },
    { id: 3,  src: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&q=80", alt: "Group Practice Session",  category: "Practice Sessions" },
    { id: 4,  src: "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=800&q=80", alt: "Kids Garba Batch",        category: "Kids Batch" },
    { id: 5,  src: "https://images.unsplash.com/photo-1547153760-18fc86324498?w=800&q=80", alt: "Navratri Stage Show",      category: "Navratri" },
    { id: 6,  src: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=800&q=80", alt: "Annual Showcase",         category: "Performance" },
    { id: 7,  src: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&q=80", alt: "Competition Training",    category: "Competition" },
    { id: 8,  src: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80", alt: "Wedding Choreography",   category: "Wedding Choreography" },
    { id: 9,  src: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80", alt: "Award Ceremony",          category: "Award Ceremony" },
    { id: 10, src: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&q=80", alt: "Group Training",          category: "Group Training" },
    { id: 11, src: "https://images.unsplash.com/photo-1583394293214-0d0e7b4e8e8e?w=800&q=80", alt: "Traditional Dress Day",   category: "Traditional Dress Day" },
    { id: 12, src: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80", alt: "Navratri Celebration",    category: "Navratri" },
  ],

  pricing: [
    {
      id: 1,
      name: "Starter",
      price: "Rs.999",
      period: "per month",
      features: [
        "3 Classes per Week",
        "Beginner Garba Steps",
        "Practice Music Access",
        "Annual Day Participation",
      ],
      highlighted: false,
    },
    {
      id: 2,
      name: "Weekend",
      price: "Rs.2,499",
      period: "per month",
      features: [
        "Saturday & Sunday Batches",
        "Garba + Dandiya Raas",
        "Costume Guidance",
        "Stage Performances",
        "WhatsApp Practice Group",
      ],
      highlighted: false,
    },
    {
      id: 3,
      name: "Professional",
      price: "Rs.4,999",
      period: "per month",
      features: [
        "Daily Classes",
        "Advanced Choreography",
        "Competition Training",
        "Priority Stage Slots",
        "Personal Feedback Sessions",
        "Navratri Special Access",
      ],
      highlighted: true,
    },
    {
      id: 4,
      name: "Personal Coaching",
      price: "Rs.9,999",
      period: "per month",
      features: [
        "1-on-1 Daily Sessions",
        "Custom Choreography",
        "Competition Mentoring",
        "Video Analysis & Feedback",
        "Flexible Timings",
        "Priority Booking",
      ],
      highlighted: false,
    },
    {
      id: 5,
      name: "Wedding Package",
      price: "Custom Quote",
      period: "per event",
      features: [
        "Custom Sangeet Choreography",
        "Family Group Training",
        "Costume Coordination",
        "Rehearsal Support",
        "Day-of Performance Guidance",
        "Video Documentation",
      ],
      highlighted: false,
    },
  ],

  testimonials: [
    { id: 1, name: "Priya Patel",    role: "Parent, Ahmedabad",          review: "My daughter joined the Kids Batch 2 years ago. The improvement in her confidence, posture, and grace is remarkable. Raas Rhythm feels like a second family!", rating: 5, avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80" },
    { id: 2, name: "Rajan Shah",     role: "Adult Learner, Vadodara",    review: "I joined at 38 with zero dance background. The instructors were incredibly patient. I performed on stage at Navratri — something I never imagined possible!", rating: 5, avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80" },
    { id: 3, name: "Meera Joshi",    role: "Competition Winner, Surat",  review: "Won first place at the State Garba Championship. The competition training here is unmatched. Coach Dhruv's attention to detail made all the difference.", rating: 5, avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80" },
    { id: 4, name: "Kavya Desai",    role: "Bride, Rajkot",              review: "The wedding choreography package was absolutely perfect. Our entire family performed at the Sangeet and everyone was blown away. Highly recommend!", rating: 5, avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=100&q=80" },
    { id: 5, name: "Nikhil Trivedi", role: "Corporate Client, Gandhinagar", review: "We booked the Corporate Workshop for our team of 60. It was the most fun team-building activity we've ever done. Everyone is still talking about it!", rating: 5, avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&q=80" },
    { id: 6, name: "Hetal Shah",     role: "Beginner Student, Ahmedabad", review: "I was nervous to join as a complete beginner but the environment here is so warm and encouraging. Within 3 months I was performing on stage!", rating: 5, avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&q=80" },
    { id: 7, name: "Dhara Mehta",    role: "Parent of 2 Students",       review: "Both my kids attend the Kids Batch. They look forward to every class. The instructors make learning so joyful and the cultural values they teach are priceless.", rating: 5, avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&q=80" },
    { id: 8, name: "Vishal Rana",    role: "Advanced Batch, Ahmedabad",  review: "The advanced training at Raas Rhythm is genuinely world-class. The choreography, the discipline, and the stage opportunities are unlike any other academy.", rating: 5, avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80" },
  ],

  team: [
    { id: 1, name: "Guru Anita Raval",   role: "Founder & Head Choreographer", bio: "25+ years of Garba performance and teaching. Trained under Gujarat's finest Gurus. National award winner and cultural ambassador.", image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 2, name: "Dhruv Trivedi",      role: "Senior Choreographer",         bio: "National-level Garba and Dandiya performer. Specialises in stage choreography and competition training.", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 3, name: "Nisha Bhatt",        role: "Kids Batch Instructor",        bio: "Certified in child-friendly dance pedagogy. Creates a joyful, age-appropriate learning environment for children aged 4-14.", image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 4, name: "Kiran Mehta",        role: "Competition Coach",            bio: "Trained 50+ state and national competition winners. Expert in performance psychology and stage presence.", image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
    { id: 5, name: "Pooja Sharma",       role: "Wedding Choreography Specialist", bio: "Specialises in Sangeet and wedding Garba choreography. Has choreographed 200+ weddings across Gujarat and beyond.", image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80", social: { linkedin: "#", twitter: "#" } },
  ],

  faq: [
    { id: 1, question: "Do beginners need any prior experience?",          answer: "Absolutely not. Our Beginner Batch is designed from scratch. We welcome complete newcomers of all ages and backgrounds." },
    { id: 2, question: "Can I join after Navratri has already started?",   answer: "Yes! We accept enrollments throughout the year. For Navratri, we have special catch-up sessions to help late joiners get up to speed quickly." },
    { id: 3, question: "Do you offer ladies-only batches?",                answer: "Yes, we have dedicated Ladies Special Batches with female instructors in a comfortable, private setting." },
    { id: 4, question: "Do you provide personal coaching?",                answer: "Yes. Our Personal Coaching package offers 1-on-1 sessions with a senior instructor tailored entirely to your goals and schedule." },
    { id: 5, question: "Can I join with my friends as a group?",           answer: "Absolutely! Group enrollments are welcome. We also offer group discounts for 5 or more students joining together." },
    { id: 6, question: "Do you prepare students for competitions?",        answer: "Yes. Our Competition Preparation batch is specifically designed for state and national level Garba competitions with intensive coaching." },
    { id: 7, question: "Do you organize performances and events?",         answer: "Yes! We organize annual showcases, Navratri performances, and participate in cultural festivals. All students get stage opportunities." },
  ],

  cta: {
    heading: "Ready to Begin Your Garba Journey?",
    subheading:
      "Join 15,000+ students who have discovered the joy, culture, and confidence of Garba at Raas Rhythm Academy.",
    buttonLabel: "Book Your Free Demo Class",
    buttonLink: "/garba/contact",
  },

  footer: {
    tagline: "Learn Traditional Garba with Passion, Rhythm & Perfection.",
    copyright: `© ${new Date().getFullYear()} Raas Rhythm Garba Academy. All Rights Reserved.`,
    links: [
      { label: "Home",     path: "/garba" },
      { label: "Programs", path: "/garba/services" },
      { label: "Gallery",  path: "/garba/gallery" },
      { label: "Contact",  path: "/garba/contact" },
    ],
  },

  products: [
    { id: 1,  name: "Beginner Batch",          category: "Group Batches",    price: 999,   originalPrice: 1499,  image: "https://images.unsplash.com/photo-1504609813442-a8924e83f76e?w=600&q=80",  description: "3 classes/week. Covers 2-step, 3-step, basic Raas. Perfect for absolute beginners. Duration: 1 month.", badge: "Most Popular", inStock: true, enquireMode: true },
    { id: 2,  name: "Advanced Batch",          category: "Group Batches",    price: 4999,  originalPrice: 6999,  image: "https://images.unsplash.com/photo-1545959570-a94084071b5d?w=600&q=80",  description: "Daily classes. Stage choreography, competition prep, fusion Garba. Duration: 1 month.", badge: "Pro Level", inStock: true, enquireMode: true },
    { id: 3,  name: "Weekend Batch",           category: "Group Batches",    price: 2499,  originalPrice: 3499,  image: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=600&q=80",  description: "Saturday & Sunday only. Garba + Dandiya Raas. Ideal for working professionals. Duration: 1 month.", badge: "Flexible", inStock: true, enquireMode: true },
    { id: 4,  name: "Ladies Special Batch",    category: "Group Batches",    price: 1499,  originalPrice: 1999,  image: "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=600&q=80",  description: "Ladies-only batch with female instructors. Morning & evening slots. Safe and comfortable environment.", badge: "Ladies Only", inStock: true, enquireMode: true },
    { id: 5,  name: "Kids Batch",              category: "Kids",             price: 999,   originalPrice: 1299,  image: "https://images.unsplash.com/photo-1547153760-18fc86324498?w=600&q=80",  description: "Age 4-14. Fun, structured Garba training. Builds rhythm, confidence, and cultural pride. Duration: 1 month.", badge: "Age 4-14", inStock: true, enquireMode: true },
    { id: 6,  name: "Wedding Choreography",    category: "Special Programs", price: null,  originalPrice: null,  image: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=600&q=80",  description: "Custom Sangeet & Garba choreography for the entire family. Includes rehearsals and day-of support.", badge: "Custom Quote", inStock: true, enquireMode: true },
    { id: 7,  name: "Corporate Package",       category: "Special Programs", price: null,  originalPrice: null,  image: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&q=80",  description: "Team-building Garba workshop for 20-200 employees. Customised duration and format.", badge: "For Teams", inStock: true, enquireMode: true },
    { id: 8,  name: "Personal Coaching",       category: "1-on-1",           price: 9999,  originalPrice: 12999, image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&q=80",  description: "1-on-1 daily sessions with a senior instructor. Fully customised to your goals and schedule.", badge: "Premium", inStock: true, enquireMode: true },
    { id: 9,  name: "Navratri Bootcamp",       category: "Special Programs", price: 3499,  originalPrice: 4999,  image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80",  description: "10-day intensive pre-Navratri training. All 9 nights choreography, costume guidance, and stage prep.", badge: "Seasonal", inStock: true, enquireMode: true },
    { id: 10, name: "Competition Batch",       category: "Competition",      price: 5999,  originalPrice: 7999,  image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&q=80",  description: "Intensive competition training for state and national Garba championships. Limited seats.", badge: "Champions", inStock: true, enquireMode: true },
  ],

  sections: {
    hero: true,
    about: true,
    services: true,
    whyUs: true,
    stats: true,
    gallery: true,
    pricing: true,
    testimonials: true,
    team: true,
    faq: true,
    cta: true,
    contact: true,
    products: true,
    enquireMode: true,
  },
};

export default garbaConfig;
